module.exports = __webpack_public_path__ + "img/nl_32.70415aef.png";